/**
 * Sandbox do Banco Inter (API de homologação) costuma aceitar chamadas apenas em dias úteis,
 * em janela compatível com 08:00–19:59 no horário de Brasília.
 */

/** Ambientes em que o admin aponta para o sandbox do Inter (local ou staging). */
export function isLocalOrStagingForInterSandbox(): boolean {
  if (process.env.NODE_ENV === 'development') return true;
  const deploy = (process.env.REACT_APP_DEPLOY_ENV || '').trim().toLowerCase();
  if (deploy === 'staging' || deploy === 'local') return true;
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname.toLowerCase();
  return h === 'localhost' || h === '127.0.0.1' || h.includes('staging');
}

/** Segunda a sexta, 08:00–19:59 em America/Sao_Paulo. */
export function isWithinInterSandboxBankWindow(now: Date = new Date()): boolean {
  const weekday = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Sao_Paulo',
    weekday: 'short'
  }).format(now);
  if (!['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].includes(weekday)) return false;

  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'America/Sao_Paulo',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false
  }).formatToParts(now);
  const hour = parseInt(parts.find(p => p.type === 'hour')?.value ?? '0', 10);
  const minute = parseInt(parts.find(p => p.type === 'minute')?.value ?? '0', 10);
  const t = hour * 60 + minute;
  const start = 8 * 60;
  const end = 19 * 60 + 59;
  return t >= start && t <= end;
}

export function shouldSkipInterSandboxWebhookRequests(now: Date = new Date()): boolean {
  return isLocalOrStagingForInterSandbox() && !isWithinInterSandboxBankWindow(now);
}
